// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-logo-svg[data-v-8c821574]{display:inline-block}svg[data-v-8c821574]{width:100%}`, "",{"version":3,"sources":["webpack://./client/components/SVGs/StripeLogo.vue"],"names":[],"mappings":"AAGA,kCACE,oBAAA,CAGF,qBACE,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
